import React, { ChangeEventHandler } from "react";
import styled from "styled-components";
import { colorPrimary } from "~/lib/constants";

type Props = {
  children?: React.ReactNode;
  checked?: boolean;
  id: string;
  name: string;
  onChange?: (id: string) => void;
  value: string;
};

const Radio: React.FC<Props> = ({
  children,
  checked = false,
  id,
  name,
  onChange,
  value,
}) => {
  const handleRadioChange: ChangeEventHandler = (e) => {
    onChange?.(e.currentTarget.id);
  };

  return (
    <Container>
      <Input
        checked={checked}
        id={id}
        name={name}
        type="radio"
        onChange={handleRadioChange}
        value={value}
      />
      <Label checked={checked} htmlFor={id}>
        {children}
      </Label>
    </Container>
  );
};

const Container = styled.div``;

const Input = styled.input`
  display: none;
`;

const Label = styled.label<{ checked: boolean }>`
  background: ${({ checked }) =>
    checked ? colorPrimary[500] : colorPrimary[50]};
  border-radius: 5px;
  color: ${({ checked }) => (checked ? "white" : colorPrimary[500])};
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  text-decoration: ${({ checked }) => (checked ? null : "underline")};
  padding: 4px 12px;
`;

export default Radio;
